import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ExitReasonQuestion from '../ExitReasonQuestion';
import styles from './index.module.scss';
import {
    ACCOUNT_ENTRY_LABEL,
    shouldShowAccountEntry,
} from '../../pages/Goodbye/exitReasonPresentation';

// The quiet entry under the subscription details.
//
// Andrew's instruction on 2026-10-01 was exact and it is the whole design of this
// component: "it needs to be not obvious. not hidden, but i don't want it to be
// prominent for people when not looking." So it is one line of plain text, below the
// plan details rather than beside them, rendered as a link and never as a button, and it
// opens the question in place instead of navigating anywhere.
//
// It is also not a cancel button. Cancellation stays a request through us, which was
// Andrew's own answer on self-serve-upgrades-scope the same morning.
const ExitReasonEntry = () => {
    const user = useSelector((state) => state.personality.user);
    const [open, setOpen] = useState(false);

    if (!shouldShowAccountEntry(user)) return null;

    if (open) {
        return (
            <div className={styles.entry}>
                <ExitReasonQuestion variant="account" onDismiss={() => setOpen(false)} />
            </div>
        );
    }

    return (
        <div className={styles.entry}>
            <button type="button" className={styles.link} onClick={() => setOpen(true)}>
                {ACCOUNT_ENTRY_LABEL}
            </button>
        </div>
    );
};

export default ExitReasonEntry;
